'use strict';

/**
 * @generated SignedSource<<e38997c83ffc4aeb30a2bd800daa1cbf>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "offerId",
        "storageKey": null
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "channel"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "DeliveryItemsFieldFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "Item",
                "kind": "LinkedField",
                "name": "shippableItems",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageUrl",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "itemId",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "quantity",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                    },
                    (v0 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "channel",
                        "variableName": "channel"
                    }
                ],
                "concreteType": "ProductOfferImage",
                "kind": "LinkedField",
                "name": "productOfferImages",
                "plural": true,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Cart",
        "abstractKey": null
    };
})();
node.hash = "4afa593c6988f85c53a437825686cd1c";

module.exports = node;
